const styles = `:host {
  position: relative;
  white-space: normal;
  pointer-events: none;
}
:host .tooltip {
  border: none;
  box-shadow: var(--goto-elevation-medium);
  background: var(--goto-surface-color-inverted);
  color: var(--goto-type-color-inverted);
  padding: var(--goto-spacing-01) var(--goto-spacing-02);
  border-radius: var(--goto-radius-small);
}
:host .tooltip slot {
  display: block;
  max-width: 14rem;
  width: max-content;
  white-space: initial;
}
:host chameleon-anchor-region {
  z-index: inherit;
}
:host chameleon-anchor-region.top .tooltip {
  margin-bottom: 7px;
}
:host chameleon-anchor-region.bottom .tooltip {
  margin-top: 7px;
}
:host chameleon-anchor-region.left .tooltip {
  margin-right: 7px;
}
:host chameleon-anchor-region.right .tooltip {
  margin-left: 7px;
}`; export default styles;